import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12 * (props.wx ?? 1)}
    height={30 * (props.hx ?? 1)}
    viewBox="0 0 12 30"
    fill="none"
    className={props.className}
  >
    <path
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.68 20.851c.174-.683.4-1.099.684-1.554.259-.413.5-.75.538-1.236.235-2.906 1.097-7.987 1.239-12.11.137-3.992 1.156-4.777 1.662-4.739C6.363 1.255 6.415 3 7 5.66c.628 2.857.898 4.43 1.257 6.448.4 2.246.414 3.451.67 4.927.144.825.245 1.367.377 1.782.158.502.251.738.569 1.269.613 1.024 1.119 5.498.194 6.84-.56.815-.911 1.163-1.72 1.39-.511.144-1.633.783-2.49.798-.805.015-1.464-.239-2.615-.572-.784-.227-1.227-.38-1.78-1.089-.909-1.167-.278-4.646.22-6.6z"
    />
  </svg>
);
export default SvgNormal;
